import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const settingMenus = (): CloudPremisePluginMenu[] => {
    return [
        {
            name: "Setup Firebase",
            key: "setupfirebase",
            route: "/firebase/setup",
            privacy: "private",
        },
    ];
};

export default settingMenus;